import { Box, Button, Divider, List, ListItem, Link } from '@mui/material';
import {
  Heading,
  Subheading
} from '@natomalabs/natomui/src/components/Typography';
import { LogoutPath, RegisterPath, orgUrl } from '../lib/paths';
import { useGetMyOrgsQuery } from '@/__generated__/graphql';
import LoadingState from './LoadingState';
import { redirect } from 'next/navigation';
import useEnvironment from '../providers/Environment';
import HomeViewPaper from './HomeViewPaper';
import { BuildingIcon } from '@natomalabs/natomui/src/icons';
import useToast from '../providers/Toast';
import { useEffect, useRef } from 'react';

export default function HomeOrgPicker() {
  const { loading, data } = useGetMyOrgsQuery();
  const { natoma, auth } = useEnvironment();
  const { showToast } = useToast();

  const renderedToast = useRef<boolean>(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('error') && !renderedToast.current) {
      renderedToast.current = true;
      showToast('Error', {
        description: searchParams.get('error'),
        variant: 'error'
      });
    }
  }, [showToast]);

  if (loading) return <LoadingState />;
  if (data?.myOrgs.length === 0) {
    redirect(RegisterPath);
  }

  return (
    <HomeViewPaper>
      <Heading
        sx={(theme) => ({ fontWeight: 700, lineHeight: theme.spacing(4.5) })}
      >
        Hello, it looks like you already have a Natoma account!
      </Heading>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        <List
          sx={{
            display: 'flex',
            flexDirection: 'column',
            mt: 4,
            py: 0,
            gap: 2.5
          }}
        >
          {data?.myOrgs.map((org, i) => (
            <ListItem key={i} sx={{ p: 0 }}>
              <Button
                href={orgUrl(org.slug, natoma.rootDomain)}
                LinkComponent={Link}
                startIcon={<BuildingIcon />}
              >
                {org.displayName || 'unknown'}
              </Button>
            </ListItem>
          ))}
        </List>
        <Divider />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {!auth.disableTenantRegistration && (
            <>
              <Subheading
                sx={(theme) => ({
                  fontWeight: 400,
                  color: theme.palette.text.secondary
                })}
              >
                Or create a new organization to get started
              </Subheading>
              <Button fullWidth href="/register">
                <Subheading fontWeight={600}>
                  Create a new organization
                </Subheading>
              </Button>
            </>
          )}
          <Button fullWidth href={LogoutPath}>
            <Subheading fontWeight={600}>Logout</Subheading>
          </Button>
        </Box>
      </Box>
    </HomeViewPaper>
  );
}
